<template>
  <el-col :span="8" class="statistic-graph">
    <el-card class="data" v-loading="loading_users">
      <div slot="header" class="card-header">
        <div class="card-header__title">
          <img class="report-img" src="@/assets/images/sign-in.svg" alt="" width="32"/>
          <span>NEW SIGN-UPS</span>
        </div>
        <div class="card-header__filter">
          <el-select v-model="filter" placeholder="Filter Videos" @change="filterUsers">
            <el-option v-for="type in types" :key="type" :label="type" :value="type.toLocaleLowerCase()">
            </el-option>
          </el-select>
        </div>
        <div class="card-header__total">Total: {{ total }}</div>
      </div>
      <GChart
        type="ColumnChart"
        :data="graphType.data"
        :options="graphType.chart"
        v-if="graphType.data.length > 1"
      />
      <div v-else class="no-data"><span>No Data</span></div>
      <div class="card-footer">
        <div class="border"></div>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import {mapState, mapActions, mapGetters, mapMutations} from 'vuex'
import { GChart } from 'vue-google-charts'
export default {
  data() {
    return {
      types: ['Default', 'Tier', 'Platform']
    }
  },

  components: {
    GChart
  },

  computed: {
    ...mapState('adminDashboard', [
        'ColumnChart', 'loading_users', 'filterUser', 'new_users', 'userTiersAndPlatformsChart'
    ]),
    ...mapGetters('adminDashboard', ['users_chart', 'tiersChart', 'platformsChart']),

    graphType() {
      if (this.filterUser === 'default') return { chart: this.ColumnChart, data: this.users_chart }

      else if (this.filterUser === 'tier') return { chart: this.userTiersAndPlatformsChart, data: this.tiersChart }

      else if (this.filterUser === 'platform') {
        let chartOption = JSON.parse(JSON.stringify(this.userTiersAndPlatformsChart))
        chartOption.colors[1] = '#D40C41'

        return { chart: chartOption, data: this.platformsChart }
      }
      return {}
    },

    filter: {
      get() {
        return this.$store.getters['adminDashboard/getFilterUser']
      },
      set(value) {
        this.$store.commit('adminDashboard/setFilterUser', value)
      }
    },

    total() {
      let total = 0
      if (this.filterUser === 'default') {

        this.new_users.forEach(data => {
          total+= data.verified + data.unverified + data.artists + data.labels
        })
      } else if (this.filterUser === 'tier') {

        this.new_users.forEach(data => {
          total+= data.nano + data.micro + data.mid + data.macro + data.elite
        })
      }
      else if (this.filterUser === 'platform') {

        this.new_users.forEach(data => {
          total+= data.pending + data.approved + data.rejected
        })
      }
      return this.commaNum(total)
    }
  },

  methods: {
    ...mapActions('adminDashboard', ['readNewUsers']),
    ...mapMutations('adminDashboard', ['setNewUsersData']),

    filterUsers(value) {
      this.setNewUsersData([])
      this.readNewUsers(value)
    }
  }
}
</script>

